import React, { memo, Fragment } from 'react'
import prop from 'ramda/src/prop'
import withStyles from '@material-ui/core/styles/withStyles'
import submitFormHandler from 'root/src/client/logic/form/handlers/submitFormHandler'
import classNames from 'classnames'
import { errorColor, ltGtMediaQuery } from 'root/src/client/web/commonStyles'
import HorizontalLine from 'root/src/client/web/base/HorizontalLine'
import ddAnonImage from 'root/src/client/public/dd-anon-image.jpg'
import CommentWrapper from 'root/src/client/web/list/listComponents/CommentsList/CommentWrapper'
import Button from 'root/src/client/web/base/Button'
import Fields from './Fields'

const styles = {
	root: {},
	replyRoot: {
		// margin: [[0, 0, 0, 30]],
	},
	form: {
		margin: [[50, 'auto', 0]],
		width: '100%',
		[ltGtMediaQuery]: {
			width: '100%',
			maxWidth: 'initial',
			height: 'initial',
			margin: [[40, 'auto', 32]],
		},
	},
	commentWrapper: {
		display: 'flex',
		width: '100%',
	},
	submits: {
		display: 'flex',
		maxWidth: 289,
		height: 40,
		marginLeft: 75,
		'& span': {
			textTransform: 'none',
		},
	},
	button: {
		width: 96,
		height: 36,
		margin: [[0, 14, 0, 0]],
	},
	errorText: {
		color: errorColor,
		margin: [[5, 0, 10, 0]],
		marginLeft: 75,
		[ltGtMediaQuery]: {
			marginLeft: 55,
		},
	},
	image: {
		borderRadius: 200,
		height: 60,
		width: 60,
		minHeight: 60,
		minWidth: 60,
		overflow: 'hidden',
		marginRight: 16,
		backgroundSize: 'cover',
		[ltGtMediaQuery]: {
			height: 40,
			width: 40,
			minHeight: 40,
			minWidth: 40,
			marginRight: 12,
		},
	},
	comments: {
		width: 220,
		fontSize: 18,
	},
	date: {
		width: 110,
		fontSize: 18,
		textAlign: 'right',
		[ltGtMediaQuery]: {
			width: '40%',
		},
		'@media (max-width: 320px)': {
			fontSize: 16,
		},
	},
	length: {
		width: 'inherit',
		margin: [[0, 'auto']],
	},
	buttons: {
		display: 'flex',
	},
	formWrapper: {
		[ltGtMediaQuery]: {
			padding: [[0, 12]],
		},
	},
}

const CommentForm = memo(({
	formFieldTypes, moduleId, moduleKey, submitForm,
	classes, formType, visibleLoadingInput,
	formSubmitError, onBlur, onClick, isMobileRes,
	creatorData, commentAmount, children, displayForm,
	isReply, setReplyFormOpen,
}) => (
	<CommentWrapper>
		<div
			className={classNames(
				classes.root,
				'layout-column layout-align-center',
				{ [classes.replyRoot]: isReply },
			)}
		>
			<div className="layout-row">
				{commentAmount > 0
			&& (
				<div className={classes.comments}>
					{commentAmount} Comment{commentAmount > 1 && 's'}
				</div>
			)}
				{!isReply && <HorizontalLine commentForm />}
			</div>
			{displayForm && (
				<form
					className={classNames('layout-column layout-align-space-between-stretch', classes.form)}
					onSubmit={submitFormHandler(submitForm, moduleKey)}
				>
					<div className={classNames('layout-row', classes.formWrapper)}>
						<div
							className={classes.image}
							style={{	backgroundImage: `url(${prop('image', creatorData) || ddAnonImage})`	}}
						/>
						<div className={classes.commentWrapper}>
							{formFieldTypes
								?	(
									<Fields
										moduleKey={moduleKey}
										moduleId={moduleId}
										formFieldTypes={formFieldTypes}
										formType={formType}
										onBlur={onBlur}
										onClick={onClick}
										visibleLoadingInput={visibleLoadingInput}
									/>
								)
								: children
							}
						</div>
					</div>
					{formSubmitError
									&& (
										<div
											className={classNames(classes.errorText)}
										>
											{formSubmitError.errorString}
										</div>
									)}
					{!isMobileRes
						&& (
							<div className={classNames(classes.submits)}>
								{!isReply
									? (
										<div className={classes.button}>
											<Button buttonType="commentButton" onClick={submitFormHandler(submitForm)}>Comment</Button>
										</div>
									)
									: (
										<Fragment>
											<div className={classes.button}>
												<Button buttonType="commentButton" onClick={submitFormHandler(submitForm)}>Reply</Button>
											</div>
											<div className={classes.button}>
												<Button buttonType="secondaryButton" onClick={() => setReplyFormOpen(false)}>Cancel</Button>
											</div>
										</Fragment>
									)
								}
							</div>
						)
					}
					<input type="submit" className="hide" />
				</form>
			)}
		</div>
	</CommentWrapper>
))

export default withStyles(styles, { name: 'MuiCommentForm' })(CommentForm)
